import React from 'react';

import type { GameState } from '../../types/game';
import { readSession, resolveSessionIdentity, writeSession } from '../../utils/sessionContract';
import { saveHostFlag } from '../../utils/hostFlag';

const LAST_ONLINE_GAME_KEY = 'dice1k_last_online_game';

export function useSessionContract({
  gameState,
  isHost,
}: {
  gameState: GameState;
  isHost: boolean;
}) {
  React.useEffect(() => {
    const hasGameData =
      Boolean(gameState.id) ||
      (gameState.players && gameState.players.length > 0) ||
      Boolean(gameState.startedAt) ||
      (gameState.events && gameState.events.length > 0);
    if (!hasGameData) return;
    if (isHost) saveHostFlag(true);
  }, [isHost, gameState.events, gameState.id, gameState.players, gameState.startedAt]);

  React.useEffect(() => {
    if (gameState.mode === 'REAL') {
      try { localStorage.removeItem(LAST_ONLINE_GAME_KEY); } catch {}
    }
  }, [gameState.mode]);

  React.useEffect(() => {
    if (gameState.mode === 'ONLINE' && gameState.id) {
      try {
        localStorage.setItem(LAST_ONLINE_GAME_KEY, gameState.id);
        const session = readSession();
        const sessionIdentity = resolveSessionIdentity(session);
        const persistedRoomId = gameState.roomId || gameState.groupToken || null;
        const persistedCurrentRoundId = gameState.currentRoundId || gameState.id || null;
        if (
          session?.mode === 'ONLINE'
          && (
            session.gameId !== gameState.id
            || sessionIdentity.roomId !== persistedRoomId
            || sessionIdentity.currentRoundId !== persistedCurrentRoundId
          )
        ) {
          writeSession({
            ...session,
            gameId: gameState.id,
            roomId: persistedRoomId,
            currentRoundId: persistedCurrentRoundId,
            updatedAt: new Date().toISOString(),
          });
        }
      } catch {}
    }
  }, [gameState.currentRoundId, gameState.groupToken, gameState.id, gameState.mode, gameState.roomId]);
}
